import { useRef } from 'react';

import { EditAccountModal, EditAccountModalHandle } from 'pages/account/my_account/components';
import { useMyAccount } from 'pages/account/my_account/context';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useApp } from 'app';

export const General = props => {

    const { currentUser } = useApp();
    const { permissions } = useMyAccount();

    const editModalRef = useRef<EditAccountModalHandle>(null);

    const launchEditModal = () => {

        const modal = editModalRef?.current;
        if (!modal) return;

        modal.show();

    };

    return (
        <div className={'general'}>
            <div className="d-flex justify-content-between mb-3">
                <h3 className="text-strong">
                    <FormattedMessage defaultMessage="General Info" id="general_info.d56ce80b" />
                </h3>

                {permissions.Edit && permissions.UserEdit && (
                    <Button onClick={launchEditModal}>
                        <i className="fa-solid fa-pen me-2" />
                        <FormattedMessage defaultMessage="Edit" id="edit.00978daf" />
                    </Button>
                )}
            </div>

            <dl className={'d-flex flex-column gap-2'}>

                <div>
                    <dt className="text-strong fw-semibold">
                        <FormattedMessage defaultMessage="Username" id="username.dceab582" />
                    </dt>
                    <dd>
                        {currentUser.userName}
                    </dd>
                </div>

                <div>
                    <dt className="text-strong fw-semibold">
                        <FormattedMessage defaultMessage="First Name" id="first_name.759a675b" />
                    </dt>
                    <dd>
                        {currentUser.firstName}
                    </dd>
                </div>

                <div>
                    <dt className="text-strong fw-semibold">
                        <FormattedMessage defaultMessage="Last Name" id="last_name.029e7273" />
                    </dt>
                    <dd>
                        {currentUser.lastName}
                    </dd>
                </div>

                <div>
                    <dt className="text-strong fw-semibold">
                        <FormattedMessage defaultMessage="Status" id="status.ad856ad7" />
                    </dt>
                    <dd>
                        {currentUser.active ? <FormattedMessage defaultMessage="Active" id="active.b9616c88" /> : <FormattedMessage defaultMessage="Inactive" description="New" id="inactive.5ee46a1c" />}
                    </dd>
                </div>

                <div>
                    <dt className="text-strong fw-semibold">
                        <FormattedMessage defaultMessage="Early Access" id="early_access.86082dfe" />
                    </dt>
                    <dd>
                        {currentUser.earlyAccessPreference === 0
                            ? 'Enabled'
                            : 'Disabled'
                        }
                    </dd>
                </div>

            </dl>

            <EditAccountModal ref={editModalRef} />
        </div>
    );

};